<ion-header>
  <ion-toolbar class="ion-text-center">
    <ion-title>Reset Password</ion-title>

    <ion-buttons slot="end">
      <ion-button fill="clear" (click)="close()">
        <ion-icon name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <h4>Email</h4>
  <ion-item class="password-input">
    <ion-input
      type="text"
      [formControl]="formControl"
      autofocus="true"
      clearInput="true"
      inputmode="email"
      (keyup.enter)="verifyEmail(false)"
    ></ion-input>
  </ion-item>

  <ion-item
    lines="none"
    class="no-background submit-button ion-text-center ion-justify-content-center ion-align-item-center"
  >
    <ion-label>
      <ion-button #submitBtn class="hub-btn" (click)="verifyEmail(false)" [disabled]="formControl.invalid"
        >Reset Password</ion-button
      >
    </ion-label>
  </ion-item>
</ion-content>
